import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { toast } from 'sonner';

export const AuthError: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  useEffect(() => {
    const errorMessage = searchParams.get('message');
    const origin = searchParams.get('origin');
    if (errorMessage) {
      setTimeout(() => {
        toast.error(decodeURIComponent(errorMessage), {
          id: 'auth-error',
          duration: 5000,
        });
      });
    }
    navigate(origin ?? '/');
  }, [searchParams, navigate]);

  return null;
};
